var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M4.125 0A4.124 4.124 0 0 0 0 4.114v17.601c0 2.27 1.85 4.115 4.125 4.115h6.188v5.143c0 .392.219.746.567.92.348.173.767.134 1.082-.097l7.973-5.966h8.94A4.124 4.124 0 0 0 33 21.715v-17.6C33 1.844 31.15 0 28.875 0z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.25 10.057)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.292,
    cy: 2.286,
    rx: 2.292,
    ry: 2.286
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.708,
    cy: 2.286,
    rx: 2.292,
    ry: 2.286
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.125,
    cy: 2.286,
    rx: 2.292,
    ry: 2.286
  })))));
};
export default SvgMessage;